export enum HomepageMonitoring {
    createGroup = 'Home_Group_Created',
    deleteGroup = 'Home_Group_Deleted',
    addPortlet = 'Home_Portles_Add',
    addTile = 'Home_Tiles_Added',
    groupsCount = 'groupsCount'
}

export enum ToDoListPromoMonitoring {
    accept = 'ToDoList_Promotion_AddHomepage',
    decline = 'ToDoList_Promotion_Dont_show_again',
    close = 'Promotion_AddHomepage_Close'
}

export enum AIWritingAssistantMonitoring {
    // Button clicks
    AI_mailedi_Icon = 'AI_mailedi_Icon',

    // Action selections
    AI_mailedi_tone = 'AI_mailedi_tone',
    AI_mailedi_imprv = 'AI_mailedi_imprv',
    AI_mailedi_spell = 'AI_mailedi_spell',

    // Tone options (using lowercase as specified)
    AI_mailedi_formal = 'AI_mailedi_formal',
    AI_mailedi_professional = 'AI_mailedi_professional',
    AI_mailedi_neutral = 'AI_mailedi_neutral',
    AI_mailedi_polite = 'AI_mailedi_polite',
    AI_mailedi_appreciative = 'AI_mailedi_appreciative',

    // Revert and error tracking
    AI_mailedi_ctrlz = 'AI_mailedi_ctrlz',
    AI_mailedi_err = 'AI_mailedi_err'
}

export enum AIAdvancedSearchMonitoring {
    aiSearchButtonClicked = 'AI_Search_Icon',
    searchWithAIInput = 'AI_Search_Arrow_Clicks',
    aiSearchNoResults = 'AI_Search_No_Results',
    aiSearchRun = 'AI_Search_Run',
    aiSearchSave = 'AI_Search_Save'
}

export enum RecommendedSearchMonitoring {
    recommendationDisplayed = 'Search_Reco_Shown',
    recommendationApplied = 'Search_Reco_Add'
}

export enum UpgradeDialogMonitoring {
    next = 'Upgrade_pop_NEXT',
    accept = 'Upgrade_pop_send_approve',
    decline = 'Upgrade_pop_dont'
}

export enum EOYPromoMonitoring {
    start = 'eoy_promotion_lets',
    reject = 'eoy_promotion_dont',
    close = 'eoy_promotion_x',
    link = 'eoy_promotion_link'
}
